export const footer = {
  newsletter: {
    label: "Newsletteranmeldung",
    inputLabels: {
      email: "E-Mail",
      next: "Weiter",
      salutation: "Anrede",
      firstname: "Vorname",
      lastname: "Nachname",
      company: "Firma",
      address: "Straße und Hausnummer",
      postalCode: "Postleitzahl",
      city: "Ort",
      privacyStatement: "Datenschutzerklärung",
      privacyStatementCheckbox:
        "Ich erkläre mich damit einverstanden, dass die Maagtechnic AG meine Daten zur Bearbeitung meines Anliegens verwendet. Weitere Informationen und Widerrufshinweise finden Sie in unserer ",
      send: "Absenden",
    },
    requiredFieldsMissing: "Nicht alle Pflichtfelder ausgefüllt",
  },
  socialMedia: {
    label: "Folgen Sie uns auch auf",
  },
  legal: {
    label: "Rechtliches",
    links: {
      termsAndConditions: {
        link:
          "https://maagtechnic.ch/content/dam/ch/pdf/unternehmen/rechtliches/Maagtechnic%20AGB_DE_0819.pdf",
        text: "AGB",
      },
      imprint: {
        link: "https://maagtechnic.ch/de/ueber-uns/impressum/",
        text: "Impressum",
      },
      disclaimer: {
        link: "https://maagtechnic.ch/de/ueber-uns/disclaimer/",
        text: "Disclaimer",
      },
      privacy: {
        link: "https://maagtechnic.ch/de/privacy/",
        text: "Datenschutzerklärung",
      },
    },
  },
};
